import "./Settings.css";

export function Settings() {
  return <>Settings page</>;
}
